import BaseProfileValidator, { ProfileFields } from '@/utils/validators/shared/base/Profile'
import { isEmail, isEmailMaxLength, isYear, isMonth, isDay } from '@/utils/validators/helper'

const regExLegacyPassword = /^[0-9a-zA-Z]*$/
const regExPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[0-9a-zA-Z]*$/

export interface AuthFields extends ProfileFields {
  email: string | null
  // password はログインと会員登録の両方で同じフィールドを使い分けて使用しています。
  password: string
  passwordConfirm: string
  newPassword: string
  newPasswordConfirm: string
  birthYear: number | null
  birthMonth: number | null
  birthDay: number | null
  prefecture: string
  sex: 'f' | 'm' | null
  readFlag: boolean
}

export default class AuthValidator extends BaseProfileValidator {
  fields: Partial<AuthFields>

  constructor(fields: Partial<AuthFields>) {
    super(fields)
    this.fields = {
      ...this.fields,
      ...fields
    }
  }

  isEmailFormatValid(): boolean {
    return !!this.fields.email && isEmail(this.fields.email)
  }

  isEmailLengthValid(): boolean {
    return !!this.fields.email && !isEmailMaxLength(this.fields.email)
  }

  isEmailValid(): boolean {
    return !!this.fields.email && this.isEmailFormatValid() && this.isEmailLengthValid()
  }

  isLegacyPasswordFormatValid(): boolean {
    return !!this.fields.password && regExLegacyPassword.test(this.fields.password)
  }

  isPasswordFormatValid(): boolean {
    return !!this.fields.password && regExPassword.test(this.fields.password)
  }

  isPasswordLengthEnough(): boolean {
    return !!this.fields.password && this.fields.password.length >= 8
  }

  isLegacyPasswordLengthEnough(): boolean {
    return !!this.fields.password && this.fields.password.length >= 4
  }

  isPasswordLengthLeThanLimit(): boolean {
    return !!this.fields.password && this.fields.password.length <= 32
  }

  isPasswordLengthValid(): boolean {
    return this.isPasswordLengthEnough() && this.isPasswordLengthLeThanLimit()
  }

  isLegacyPasswordLengthValid(): boolean {
    return this.isLegacyPasswordLengthEnough() && this.isPasswordLengthLeThanLimit()
  }

  isPasswordConfirmFormatValid(): boolean {
    return !!this.fields.passwordConfirm && regExLegacyPassword.test(this.fields.passwordConfirm)
  }

  isPasswordConfirmLengthEnough(): boolean {
    return !!this.fields.passwordConfirm && this.fields.passwordConfirm.length >= 8
  }

  isPasswordConfirmLengthLeThanLimit(): boolean {
    return !!this.fields.passwordConfirm && this.fields.passwordConfirm.length <= 32
  }

  isPasswordConfirmLengthValid(): boolean {
    return this.isPasswordConfirmLengthEnough() && this.isPasswordConfirmLengthLeThanLimit()
  }

  isPasswordConfirmValid(): boolean {
    return !!this.fields.passwordConfirm && this.isPasswordConfirmFormatValid() && this.isPasswordConfirmLengthValid()
  }

  isBirthYearValid(): boolean {
    return !!this.fields.birthYear && isYear(this.fields.birthYear)
  }

  isBirthMonthValid(): boolean {
    return !!this.fields.birthMonth && isMonth(this.fields.birthMonth)
  }

  isBirthDayValid(): boolean {
    return !!this.fields.birthDay && isDay(this.fields.birthDay)
  }
}
